var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.267857 4.5H9.73214C9.87946 4.5 10 4.62656 10 4.78125V10.875C10 11.4961 9.52009 12 8.92857 12H1.07143C0.479911 12 0 11.4961 0 10.875V4.78125C0 4.62656 0.120536 4.5 0.267857 4.5ZM10 3.46875V2.625C10 2.00391 9.52009 1.5 8.92857 1.5H7.85714V0.28125C7.85714 0.126563 7.73661 0 7.58929 0H6.69643C6.54911 0 6.42857 0.126563 6.42857 0.28125V1.5H3.57143V0.28125C3.57143 0.126563 3.45089 0 3.30357 0H2.41071C2.26339 0 2.14286 0.126563 2.14286 0.28125V1.5H1.07143C0.479911 1.5 0 2.00391 0 2.625V3.46875C0 3.62344 0.120536 3.75 0.267857 3.75H9.73214C9.87946 3.75 10 3.62344 10 3.46875Z",
    fill: "#E5E5E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2ff1b71a.svg";
export { ForwardRef as ReactComponent };